import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { DocentTimetableRow } from 'src/app/models/docent-timetable-entry.model';
import { user } from 'src/app/models/user.model';
import { isSameDay, slotLabel, timeRangeLabel } from '../../docent-timetable-helpers';
import { DocentTimetableMeetingActionsComponent } from '../docent-timetable-meeting-actions/docent-timetable-meeting-actions.component';

/** Reine Darstellung: Stundenplanseite und Benutzerdialog teilen sich dieselben Spalten. */
@Component({
  selector: 'app-docent-timetable-table',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    DocentTimetableMeetingActionsComponent,
  ],
  templateUrl: './docent-timetable-table.component.html',
  styleUrl: './docent-timetable-table.component.scss',
})
export class DocentTimetableTableComponent {
  @Input() entries: DocentTimetableRow[] = [];
  @Input() loading = false;
  @Input() rows = 20;
  @Input() emptyMessage = 'Keine Unterrichtstermine im gewählten Zeitraum.';

  /** Im Benutzerdialog gibt es keinen Platz und keinen Anlass für die Klassenbuch-Spalte. */
  @Input() showClassbook = true;

  /** Nur die Verwaltung darf Meetings je Zeile bearbeiten; sonst read-only. */
  @Input() canEditMeetings = false;

  /** Für den Meeting-Bearbeiten-Dialog nötig. */
  @Input() lecturerUsers: user[] = [];

  /** Das Öffnen des Dialogs bleibt bei der Seite — diese Tabelle stellt nur dar. */
  @Output() classbookRequested = new EventEmitter<DocentTimetableRow>();

  /** Ein Meeting wurde bearbeitet — der Aufrufer lädt den Plan neu. */
  @Output() meetingChanged = new EventEmitter<void>();

  readonly slotLabel = slotLabel;
  readonly timeRangeLabel = timeRangeLabel;

  private readonly today = new Date();

  isToday(entry: DocentTimetableRow): boolean {
    return isSameDay(entry.date, this.today);
  }
}
